const fields = [
  {
    key: 'venues',
    type: 'ntm-select',
    multiple: true,
    optionsApi: 'venues',
    templateOptions: {
      label: 'venues'
    }
  },
  {
    key: 'extendsSchedules',
    type: 'ntm-select',
    multiple: true,
    options: [],
    templateOptions: {
      label: 'extendsLeagues'
    }
  },
  {
    key: 'suffix',
    type: 'input',
    templateOptions: {
      label: 'suffix'
    }
  },
  {
    key: 'number_of_regular_periods',
    type: 'input',
    templateOptions: {
      inputType: 'number',
      label: 'number_of_regular_periods'
    }
  },
  {
    key: 'periodTime',
    type: 'input',
    templateOptions: {
      inputType: 'number',
      label: 'periodTime'
    }
  },
  {
    key: 'overtimePeriodTime',
    type: 'input',
    templateOptions: {
      inputType: 'number',
      label: 'overtimePeriodTime'
    }
  },
  {
    key: 'gameDurationInMinutes',
    type: 'input',
    templateOptions: {
      inputType: 'number',
      label: 'gameDurationInMinutes'
    }
  },
  {
    key: 'minTeamPlayers',
    type: 'input',
    templateOptions: {
      inputType: 'number',
      label: 'minTeamPlayers'
    }
  },
  {
    key: 'maxTeamPlayers',
    type: 'input',
    templateOptions: {
      inputType: 'number',
      label: 'maxTeamPlayers'
    }
  },
  {
    key: 'sponsor',
    type: 'ntm-select',
    optionsApi: 'sponsors',
    templateOptions: {
      label: 'sponsor'
    }
  },
  {
    key: 'hideLeagueRanking',
    type: 'boolean',
    templateOptions: {
      label: 'hideLeagueRanking'
    }
  },
  {
    key: 'isTournament',
    type: 'boolean',
    templateOptions: {
      label: 'isTournament'
    }
  },
  {
    key: 'showOnLandingPage',
    type: 'boolean',
    templateOptions: {
      label: 'showOnLandingPage'
    }
  },
  {
    key: 'hasAutoSyncGameYoutubeEvents',
    type: 'boolean',
    templateOptions: {
      label: 'hasAutoSyncGameYoutubeEvents'
    }
  },
  {
    key: 'has_substitutions',
    type: 'boolean',
    templateOptions: {
      label: 'has_substitutions'
    }
  },
  {
    key: 'show_player_in_game_time_on_website',
    type: 'boolean',
    templateOptions: {
      label: 'show_player_in_game_time_on_website'
    }
  },
  {
    key: 'show_player_plus_minus_on_website',
    type: 'boolean',
    templateOptions: {
      label: 'show_player_plus_minus_on_website'
    }
  },
  {
    key: 'is_exhibition',
    type: 'boolean',
    templateOptions: {
      label: 'is_exhibition'
    }
  }
]

export default fields
